<template>
    <div class="card">
        <div class="card-header">
            {{ reportId ? $t('Edit Report') : $t('Create a new Report') }}
        </div>
        <div class="card-body">
            <b-form @submit.prevent="submitForm">
                <!-- Composant TemplateSelect -->
                <template-select
                    :initial-client-id="form.client_id"
                    :initial-manufacturer-id="form.manufacturer_id"
                    :initial-template-id="form.report_template_id"
                    @update:client-id="form.client_id = $event"
                    @update:manufacturer-id="form.manufacturer_id = $event"
                    @update:template-id="form.report_template_id = $event"
                ></template-select>

                <!-- Affichage des erreurs -->
                <b-alert v-if="errors.report_template_id" variant="danger">
                    {{ errors.report_template_id }}
                </b-alert>
                <b-alert v-if="errors.manufacturer_id" variant="danger">
                    {{ errors.manufacturer_id }}
                </b-alert>

                <!-- ID et Date -->
                <b-row class="form-row">
                    <b-col md="4">
                        <b-form-group
                            :label="$t('Report ID')"
                            label-for="reportId"
                        >
                            <b-form-input
                                id="reportId"
                                v-model="form.report_id"
                                required
                                placeholder="Enter Report ID"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group
                            :label="$t('Report date')"
                            label-for="reportDate"
                        >
                            <b-form-input
                                id="reportDate"
                                type="date"
                                v-model="form.report_date"
                                required
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- Commentaire -->
                <b-row class="form-row">
                    <b-col md="8">
                        <b-form-group :label="$t('Report comment')" label-for="reportComment">
                            <b-form-textarea
                                id="reportComment"
                                v-model="form.comment"
                                rows="3"
                                placeholder="Add a comment"
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- Bouton -->
                <b-button type="submit" variant="primary" :disabled="loading">
                    <b-spinner small v-if="loading"></b-spinner>
                    {{ reportId ? $t('Update Report') : $t('Create Report') }}
                </b-button>
            </b-form>
        </div>
    </div>
</template>


<script>
import axios from "axios";
import TemplateSelect from "./TemplateSelect.vue";

export default {
  name: "QualityReportForm",
  components: { TemplateSelect },
  props: {
    reportId: {
      type: [String, Number],
      default: null
    },
    initialData: {
      type: Object,
      default: () => ({
        report_id: "",
        report_date: new Date().toISOString().substr(0, 10),
        comment: "",
        client_id: null,
        manufacturer_id: null,
        report_template_id: null
      })
    }
  },
  data() {
    return {
      form: { ...this.initialData },
      loading: false,
      errors: {}
    };
  },
  mounted() {},
  methods: {
    async submitForm() {
      this.loading = true;
      this.errors = {};

      try {
        const response = this.reportId
          ? await axios.put(`/api/reports/${this.reportId}`, this.form)
          : await axios.post("/api/reports", this.form);

        const report = response.data.data;
        this.$emit("saved", report);

        // Redirige vers la page du rapport créé
        window.location.href = `/reports/${report.id}/input`;
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.errors = error.response.data.errors;
        }
      } finally {
        this.loading = false;
      }
    },
    updateClientId(clientId) {
      this.form.client_id = clientId;
    },
    updateManufacturerId(manufacturerId) {
      this.form.manufacturer_id = manufacturerId;
    },
    updateTemplateId(templateId) {
      this.form.report_template_id = templateId;
    }
  }
};
</script>
